import { render, staticRenderFns } from "./AnswerExport.vue?vue&type=template&id=0644b78e&scoped=true"
import script from "./AnswerExport.vue?vue&type=script&lang=js"
export * from "./AnswerExport.vue?vue&type=script&lang=js"
import style0 from "./AnswerExport.vue?vue&type=style&index=0&id=0644b78e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0644b78e",
  null
  
)

export default component.exports